import React from 'react';
import {
    Card,
    CardHeader,
    CardFooter,
    Row,
    Col,
  } from "reactstrap";

export const CenterMessageCard = ( props ) =>  {
      let {
        // bgcolor, 
        children, 
        icon,
        title 
    } = props;
    
        return (
<>
    <div className="content">
    <br /><br /><br /><br /><br /><br />
            <Row>
            <Col className="col-md-6 ml-auto mr-auto">
              <Card>
                <CardHeader>
                  <Row>
                    <Col sm="12">
                      {icon && <i class={"fa " + icon + " numbers pull-right"} aria-hidden="true"></i>}
                      <div className="numbers pull-left">{title}</div>
                    </Col>
                  </Row>
                </CardHeader>
                <CardFooter>
                  <hr />
                  <Row>
                    <Col sm="12">
                        <div className="footer-title">
                            {children} 
                        </div>
                    </Col>
                   </Row>
                </CardFooter>
              </Card>
            </Col>
        </Row>
    </div>
</>
        ); 
}
